import { render } from "./UserBalance.vue?vue&type=template&id=04fb9644&scoped=true&ts=true"
import script from "./UserBalance.vue?vue&type=script&lang=ts"
export * from "./UserBalance.vue?vue&type=script&lang=ts"

import "./UserBalance.vue?vue&type=style&index=0&id=04fb9644&scoped=true&lang=css"

import exportComponent from "/home/lahiru-dhananjaya/Documents/Jeewaka/PMS/Source and Documentation/pharma-connect2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04fb9644"]])

export default __exports__